import React from "react";
import "./Product_Content.css";
import parse from "html-react-parser";

const Product_Content = ({product}) => {
  return (
    <section className="Product_Content">
      <div className="text_div">
        <p className="inner_text">
          {product?.description ? parse(product.description) : null}
        </p>
        
      </div>
    </section>
  );
};

export default Product_Content;
